import { useTranslation } from 'react-i18next';

/**
 * @param {string} role
 *
 * @returns {string}
 */
export function useGetDocumentUserRole(role) {
    const { t } = useTranslation();

    switch (role) {
        case 'documentManager':
            return t('documents:document.navbar.main.sidebar.team.roles.documentManager');
        case 'editor':
            return t('documents:document.navbar.main.sidebar.team.roles.editor');
        case 'finalEditor':
            return t('documents:document.navbar.main.sidebar.team.roles.finalEditor');
        case 'manager':
            return t('documents:document.navbar.main.sidebar.team.roles.manager');
        case 'spectator':
            return t('documents:document.navbar.main.sidebar.team.roles.spectator');
        default:
            return '';
    }
}
